// extracted by mini-css-extract-plugin
export var actions = "b2_cQ";
export var articleMultipleChoiceCTA = "b2_gp";
export var body = "b2_gr";
export var bodyContainer = "b2_gq";
export var illustration = "b2_gt";
export var selected = "b2_gx";
export var subtitle = "b2_gw";
export var textContent = "b2_gv";
export var tile = "b2_gs";
export var wrapper = "b2_b9";